import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'

export type SectionHeaderProps = {
  icon: React.ReactNode
  title: React.ReactNode
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ icon, title }) => (
  <HeaderRoot>
    <HeaderIconWrapper>{icon}</HeaderIconWrapper>
    <HeaderTitle variant="h6">{title}</HeaderTitle>
  </HeaderRoot>
)

const HeaderRoot = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
}))

const HeaderIconWrapper = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.primary.main,
  display: 'flex',
  justifyContent: 'center',
}))

const HeaderTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
}))
